import React, { useState, useEffect } from "react";
import { Button, Icon, Modal, Grid, Segment, Header, Image, Label, Popup, Divider } from "semantic-ui-react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import CustomTextareaComponent from "components/Form/CustomTextareaComponent";
import { Checkbox } from "components/Form/SpecialButtons";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { MapInteractionCSS } from "react-map-interaction";
import { b64toBlob } from "utils/file";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "components/Form/Select";
import ShortcutComment from "components/Others/ShortcutComment";

const schemaValidationDepot = (deposit_places) =>
	Yup.object().shape({
		externalSampler: Yup.string().required("Champ requis"),
		prel_place: Yup.string().required("Champ requis"),
		requireNumSeq: Yup.boolean(),
		prel_date: Yup.string(),
		numSeq: Yup.string().when("prel_place", {
			is: (val) =>
				(!!deposit_places &&
					deposit_places.some((p) => p.abbreviation === val) &&
					!deposit_places.filter((p) => p.abbreviation === val)[0].numSeqNotRequiredForDeposit) === true,

			then: Yup.string()
				.required("Champ requis")
				.test("numSeq", "Le numéro séquentiel doit être composé de 8 chiffres", (value) => {
					if (!value || value === undefined) return false;
					return value?.length === 8 && value?.match(new RegExp("^[0-9]{8}$"));
				}),
			otherwise: Yup.string()
				.nullable()
				.optional()
				.test("numSeq", "Le numéro séquentiel doit être composé de 8 chiffres", (value) => {
					if (!value || value === undefined) return true;
					return value?.length === 8 && value?.match(new RegExp("^[0-9]{8}$"));
				}),
		}),

		domicile: Yup.string(),
		rdv: Yup.string(),
	});
const schemaValidationTelesec = Yup.object().shape({
	support_reason: Yup.string(),
	urgency: Yup.boolean(),
	analyses: Yup.boolean(),
	othersComment: Yup.boolean(),
	dataPatient: Yup.boolean(),
});
const schemaValidationDepotAndTelesec = (deposit_places) =>
	Yup.object().shape({
		support_reason: Yup.string(),
		urgency: Yup.boolean(),
		analyses: Yup.boolean(),
		othersComment: Yup.boolean(),
		dataPatient: Yup.boolean(),
		externalSampler: Yup.string().required("Champ requis"),
		prel_place: Yup.string().required("Champ requis"),
		prel_date: Yup.string(),
		numSeq: Yup.string().when("prel_place", {
			is: (val) =>
				(!!deposit_places &&
					deposit_places.some((p) => p.abbreviation === val) &&
					!deposit_places.filter((p) => p.abbreviation === val)[0].numSeqNotRequiredForDeposit) === true,

			then: Yup.string()
				.required("Champ requis")
				.test("numSeq", "Le numéro séquentiel doit être composé de 8 chiffres", (value) => {
					if (!value || value === undefined) return false;
					return value?.length === 8 && value?.match(new RegExp("^[0-9]{8}$"));
				}),
			otherwise: Yup.string()
				.nullable()
				.optional()
				.test("numSeq", "Le numéro séquentiel doit être composé de 8 chiffres", (value) => {
					if (!value || value === undefined) return true;
					return value?.length === 8 && value?.match(new RegExp("^[0-9]{8}$"));
				}),
		}),
		domicile: Yup.string(),
		rdv: Yup.string(),
	});
const styles = {
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 1,
		left: 3,
	},
};

const AddNurseHelpModal = ({
	open,
	close,
	tvsec,
	deposit,
	createFolderHelp,
	folder,
	docs,
	deleteScanPrescription,
	center,
	secretaries,
	samplers,
	deposit_places,
	deposit_samplers,
	documentTypeOptions,
	getAllDocumentTypes,
}) => {
	const [barcodes, setBarcodes] = useState(
		folder.folderHelp && folder.folderHelp.barcodes ? JSON.parse(folder.folderHelp.barcodes) : [{ presc: 1, bc: { ordo: [], fpa: [], other: [] } }]
	);
	const [selectedPresc, setSelectedPresc] = useState(1);
	const [prescriptionsSet, setPrescriptionsSet] = useState([1]);
	const [prelDate, setPrelDate] = useState(moment().toDate());
	const [otherDocumentType, setOtherDocumentType] = useState(false);
	const firstTvSec = folder && !folder.folderHelp;
	useEffect(() => {
		if (docs && docs.filter((d) => d.isDefaultScan).length > 0) {
			docs.filter((d) => d.isDefaultScan).map((d) => pushBarCode(d.barcode));
		}
	}, [docs]);

	const pushBarCode = (barcode, setFieldValue) => {
		if (
			barcode &&
			barcode.length === 10 &&
			barcode.match("^[0-9]{10}$") &&
			barcode.match("^[0-9]{10}$").length > 0 &&
			!barcodes.flatMap((b) => b.bc?.ordo).includes(barcode)
		) {
			if (
				barcodes.filter((bc) => bc.presc === selectedPresc).length > 0 &&
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc &&
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc?.ordo &&
				Array.isArray(barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc?.ordo)
			)
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc.ordo.push(barcode);
			else barcodes.push({ presc: selectedPresc, bc: { ordo: [barcode], fpa: [], other: [] } });
			setBarcodes(barcodes);
			updatePrescriptionSet();
			if (setFieldValue) setFieldValue("scannedBarCode", "");
		}
	};

	const pushBarCodeFPA = (barcode, setFieldValue) => {
		if (
			barcode &&
			barcode.length === 10 &&
			barcode.match("^[0-9]{10}$") &&
			barcode.match("^[0-9]{10}$").length > 0 &&
			!barcodes.flatMap((b) => b.bc.fpa).includes(barcode)
		) {
			if (
				barcodes.filter((bc) => bc.presc === selectedPresc).length > 0 &&
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc &&
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc.fpa &&
				Array.isArray(barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc.fpa)
			)
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc.fpa.push(barcode);
			else barcodes.push({ presc: selectedPresc, bc: { ordo: [], fpa: [barcode], other: [] } });
			setBarcodes(barcodes);
			updatePrescriptionSet();
			if (setFieldValue) setFieldValue("scannedBarCodeFPA", "");
		}
	};

	const pushBarCodeOther = (barcode, documentType, setFieldValue) => {
		if (barcode && documentType && barcode.length === 10 && barcode.match("^[0-9]{10}$") && barcode.match("^[0-9]{10}$").length > 0) {
			if (
				barcodes.filter((bc) => bc.presc === selectedPresc).length > 0 &&
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc &&
				barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc.other &&
				Array.isArray(barcodes.filter((bc) => bc.presc === selectedPresc)[0].bc.fpa)
			)
				barcodes
					.filter((bc) => bc.presc === selectedPresc)[0]
					.bc.other.push({ bc: barcode, type: documentType, title: documentTypeOptions.filter((d) => d.id === documentType)[0].title });
			else
				barcodes.push({
					presc: selectedPresc,
					bc: {
						ordo: [],
						fpa: [],
						other: { bc: barcode, type: documentType, title: documentTypeOptions.filter((d) => d.id === documentType)[0].title },
					},
				});
			setBarcodes(barcodes);
			updatePrescriptionSet();
			if (setFieldValue) {
				setFieldValue("scannedBarCodeOther", "");
				setFieldValue("documentType", "");
				setOtherDocumentType(false);
			}
		}
	};

	const updatePrescriptionSet = () => {
		setPrescriptionsSet([...new Set(barcodes.map((bc) => bc.presc))]);
	};

	const addPrescription = () => {
		barcodes.push({ presc: barcodes.length + 1, bc: { fpa: [], ordo: [], other: [] } });
		setSelectedPresc(barcodes.length);
		setBarcodes(barcodes);
		updatePrescriptionSet();
	};
	const removePrescription = (prescription) => {
		setBarcodes(barcodes.filter((bc) => bc.presc !== prescription));
		setSelectedPresc(1);
		updatePrescriptionSet();
	};
	const handleKeyDown = (event, values, setFieldValue) => {
		if (event.key === "Enter") pushBarCode(values.scannedBarCode, setFieldValue);
	};
	const handleKeyDownFPA = (event, values, setFieldValue) => {
		if (event.key === "Enter") pushBarCodeFPA(values.scannedBarCodeFPA, setFieldValue);
	};

	const handleKeyDownOther = (event, values, setFieldValue) => {
		if (event.key === "Enter") pushBarCodeOther(values.scannedBarCodeOther, values.documentType, setFieldValue);
	};

	const handleKeyUpOther = (event, values, setFieldValue) => {
		pushBarCodeOther(values.scannedBarCode, values.documentType, setFieldValue);
	};

	const handleKeyUp = (event, values, setFieldValue) => {
		pushBarCode(values.scannedBarCode, setFieldValue);
	};
	const handleKeyUpFPA = (event, values, setFieldValue) => {
		pushBarCodeFPA(values.scannedBarCodeFPA, setFieldValue);
	};

	const pullBarcode = (barcode) => {
		let index = barcodes.findIndex((bc) => bc.bc.ordo.includes(barcode));
		if (index > -1) {
			barcodes[index] = {
				...barcodes[index],
				bc: { ordo: barcodes[index].bc.ordo.filter((bc) => bc !== barcode), fpa: barcodes[index].bc.fpa, other: barcodes[index].bc.other },
			};
			setBarcodes(barcodes);
		}
		updatePrescriptionSet();
	};

	const pullBarcodeFPA = (barcode) => {
		let index = barcodes.findIndex((bc) => bc.bc.fpa.includes(barcode));
		if (index > -1) {
			barcodes[index] = {
				...barcodes[index],
				bc: { fpa: barcodes[index].bc.fpa.filter((bc) => bc !== barcode), ordo: barcodes[index].bc.ordo, other: barcodes[index].bc.other },
			};
			setBarcodes(barcodes);
		}
		updatePrescriptionSet();
	};
	const pullBarcodeOther = (barcode) => {
		let index = barcodes.findIndex((bc) => bc.bc.other.map((o) => o.bc).includes(barcode));
		if (index > -1) {
			barcodes[index] = {
				...barcodes[index],
				bc: { fpa: barcodes[index].bc.fpa, ordo: barcodes[index].bc.ordo, other: barcodes[index].bc.other.filter((bc) => bc.bc !== barcode) },
			};
			setBarcodes(barcodes);
		}
		updatePrescriptionSet();
	};

	const closeAll = () => {
		setBarcodes([{ presc: 1, bc: { ordo: [], fpa: [], other: [] } }]);
		setSelectedPresc(1);
		setPrescriptionsSet([...new Set(barcodes.map((bc) => bc.presc))]);
		close();
	};
	return (
		<Modal size={!tvsec && deposit ? "small" : "fullscreen"} open={open} closeOnEscape closeOnDimmerClick onClose={closeAll}>
			<Modal.Header>
				{tvsec && (
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
						<span>
							Demande de télésecrétariat {deposit && "pour un dépôt d'un partenaire"}
							<Popup
								wide="very"
								content={
									<div>
										Scannez le ou les code-barres correspondant à la 1ère prescription.
										<br /> (1 prescription = toutes les ordonnances d’un même médecin et à la même date) <br />
										Si nécessaire, ajoutez en cliquant sur le « + », une ou plusieurs prescriptions.
										<br /> (toujours le même principe : 1 prescription = toutes les ordonnances d’un même médecin et à la même date)
									</div>
								}
								trigger={<Icon name="info circle" />}
							/>
						</span>
						{secretaries && (
							<Label color={secretaries.length > 0 ? "teal" : "red"}>
								{secretaries.length > 0 ? secretaries.length : "Pas de "} secrétaire{secretaries.length > 1 ? "s" : ""} active
								{secretaries.length > 1 ? "s" : ""}
							</Label>
						)}
					</div>
				)}
				{!tvsec && deposit && "Dépôt par un partenaire"}
			</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					folderId: folder.id,
					urgency: false,
					analyzes: true,
					othersComment: !firstTvSec,
					dataPatient: false,
					support_reason: "",
					scannedBarCode: "",
					domicile: "",
					externalSampler: "",
					rdv: "",
					numSeq: "",
					prel_place: "",
					requireNumSeq: true,
				}}
				validationSchema={
					!tvsec && deposit
						? schemaValidationDepot(deposit_places)
						: tvsec && !deposit
						? schemaValidationTelesec
						: schemaValidationDepotAndTelesec(deposit_places)
				}
				onSubmit={(values) => {
					let depositData;
					if (deposit) {
						depositData = {
							prel_date: prelDate,
							prel_place: values.prel_place,
							otherExternalSampler: values.externalSampler,
							domicile: values.domicile,
							rdv: values.rdv,
							numSeq: values.numSeq,
						};
					}
					createFolderHelp(
						values.folderId,
						values.analyzes,
						values.othersComment,
						values.support_reason,
						values.dataPatient,
						barcodes,
						center,
						depositData
					);
					closeAll();
				}}
			>
				{({ submitForm, values, setFieldValue }) => (
					<>
						<Modal.Content>
							<Grid columns={deposit && tvsec ? 2 : 1} style={{ padding: "10px", width: "100%" }}>
								{tvsec && (
									<Grid.Column>
										<Header as="h5" attached="top">
											Informations liées au télésecrétariat
										</Header>
										<Segment attached>
											<Grid>
												<Grid.Row columns={docs && docs.length > 0 ? 2 : 1}>
													{docs && docs.length > 0 && (
														<Grid.Column>
															<Header sub style={{ marginLeft: "10px" }}>
																{docs.length} document{docs.length > 1 ? "s" : ""}
															</Header>
															<div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "stretch" }}>
																<div style={{ display: "flex", justifyContent: "center", margin: "auto", marginBottom: "10px", flexWrap: "wrap" }}>
																	{docs.map((d) => (
																		<div
																			key={`doc-${d.id}`}
																			style={{
																				backgroundColor: "#f4f3f3",
																				padding: "8px",
																				borderRadius: "10px",
																				margin: "3px",
																				marginBottom: "15px",
																			}}
																		>
																			{d.type !== "application/pdf" && (
																				<div
																					style={{
																						width: "auto",
																						maxWidth: "220px",
																						padding: "2px 20px 2px 2px",
																						maxHeight: "210px",
																						overflowY: "scroll",
																					}}
																				>
																					<MapInteractionCSS minScale={1} maxScale={3}>
																						<Image
																							src={`data:${d.type};charset=utf-8;base64,${d.base64}`}
																							onContextMenu={(e) => e.preventDefault()}
																							style={{ width: "auto", height: "30vh" }}
																						/>
																						{d.base64_back && (
																							<Image
																								src={`data:${d.type};charset=utf-8;base64,${d.base64_back}`}
																								onContextMenu={(e) => e.preventDefault()}
																								style={{ width: "auto", height: "30vh" }}
																							/>
																						)}
																					</MapInteractionCSS>
																				</div>
																			)}
																			{d.type === "application/pdf" && (
																				<div
																					style={{
																						width: "auto",
																						maxWidth: "220px",
																						padding: "2px 20px 2px 2px",
																						maxHeight: "210px",
																						overflowY: "scroll",
																					}}
																				>
																					<iframe
																						id={`fra-${d.id}`}
																						//Prevent download
																						src={URL.createObjectURL(b64toBlob(d.base64, "application/pdf")) + "#toolbar=0"}
																						// src={`data:${files[fileIndex].type};base64,${files[fileIndex].base64}`}
																						title={"Ordonnance"}
																						name={d.filename}
																						style={{ width: "100%", height: "30vh" }}
																					></iframe>
																				</div>
																			)}

																			<div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "5px" }}>
																				<div>
																					{d.barcode && (
																						<Label>
																							<Icon name="barcode" />
																							{d.barcode}
																						</Label>
																					)}{" "}
																					{d.base64_back && (
																						<Label>
																							<Icon name="file outline" />
																							Recto - verso{" "}
																						</Label>
																					)}
																				</div>
																				{
																					<Button basic color="red" onClick={() => deleteScanPrescription(d)}>
																						<Icon name="trash" />
																						Supprimer
																					</Button>
																				}
																			</div>
																		</div>
																	))}
																</div>
															</div>
														</Grid.Column>
													)}
													<Grid.Column>
														{prescriptionsSet.length === 0 && (
															<div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", minHeight: "150px" }}>
																<div style={{ display: "flex", justifyContent: "space-evenly" }}>
																	<Field
																		autoFocus
																		component={CustomInputTextComponent}
																		name="scannedBarCode"
																		customlabel="Code-barres de l'ordonnance"
																		onKeyDown={(e) => {
																			handleKeyDown(e, values, setFieldValue);
																		}}
																		onKeyUp={(e) => {
																			handleKeyUp(e, values, setFieldValue);
																		}}
																	/>
																	{deposit && (
																		<Field
																			autoFocus
																			component={CustomInputTextComponent}
																			name="scannedBarCodeFPA"
																			customlabel="Code-barres de la FPA"
																			onKeyDown={(e) => {
																				handleKeyDownFPA(e, values, setFieldValue);
																			}}
																			onKeyUp={(e) => {
																				handleKeyUpFPA(e, values, setFieldValue);
																			}}
																			style={{ marginLeft: "1em" }}
																		/>
																	)}
																</div>
																<div>
																	{!otherDocumentType && (
																		<Button icon="plus" onClick={() => setOtherDocumentType(true)} label="Ajouter un autre type de documents" />
																	)}
																	{otherDocumentType && (
																		<Segment>
																			<Field
																				component={Select}
																				name="documentType"
																				customlabel={
																					<span>
																						Veuillez sélectionner un type de document{" "}
																						{getAllDocumentTypes && <Icon name="refresh" onClick={getAllDocumentTypes()} />}
																					</span>
																				}
																				placeholder="Sélectionner un type de document"
																				options={
																					documentTypeOptions
																						? documentTypeOptions.map((option) => {
																								return {
																									value: option.id,
																									label: option.title,
																								};
																						  })
																						: []
																				}
																			/>
																			<Field
																				autoFocus
																				component={CustomInputTextComponent}
																				name="scannedBarCodeOther"
																				customlabel="Code-barres"
																				onKeyDown={(e) => {
																					handleKeyDownOther(e, values, setFieldValue);
																				}}
																				onKeyUp={(e) => {
																					handleKeyUpOther(e, values, setFieldValue);
																				}}
																				style={{ marginLeft: "1em" }}
																			/>
																		</Segment>
																	)}
																</div>
															</div>
														)}
														{prescriptionsSet.length > 0 && (
															<Segment.Group horizontal>
																{prescriptionsSet.map((prescription) => (
																	<Segment
																		key={`prescr${prescription}`}
																		style={{ border: selectedPresc === prescription ? "8px solid #00b5ad82" : "" }}
																		onClick={() => setSelectedPresc(prescription)}
																	>
																		{prescription !== 1 && (
																			<Popup
																				content="Supprimer cette prescription"
																				position="top center"
																				trigger={
																					<Label
																						color="red"
																						corner
																						onClick={(e) => {
																							e.preventDefault();
																							removePrescription(prescription);
																							e.stopPropagation();
																						}}
																					>
																						<Icon name="trash"></Icon>
																					</Label>
																				}
																			/>
																		)}
																		Prescription N°{prescription} :
																		<div>
																			{barcodes
																				.filter((bc) => bc.presc === prescription)[0]
																				?.bc.ordo?.map((bc) => (
																					<div key={`bc-${prescription}-${bc}`}>
																						<Label
																							basic={
																								docs &&
																								docs
																									.filter((d) => d.barcode)
																									.map((d) => d.barcode.split("-"))
																									.includes(bc)
																									? false
																									: true
																							}
																							color={
																								docs &&
																								docs
																									.filter((d) => d.barcode)
																									.map((d) => d.barcode.split("-"))
																									.includes(bc)
																									? "green"
																									: "grey"
																							}
																							key={`bc-${bc}`}
																						>
																							{" "}
																							<Icon name="barcode" />
																							<span style={{ color: "teal" }}>Ordo : </span>
																							{bc} <Icon name="delete" onClick={(e) => pullBarcode(bc, values, setFieldValue)} />
																						</Label>
																					</div>
																				))}
																			{barcodes
																				.filter((bc) => bc.presc === prescription)[0]
																				?.bc.fpa?.map((bc) => (
																					<div key={`bc-fpa-${prescription}-${bc}`}>
																						<Label
																							basic={
																								docs &&
																								docs
																									.filter((d) => d.barcode)
																									.map((d) => d.barcode.split("-"))
																									.includes(bc)
																									? false
																									: true
																							}
																							color={
																								docs &&
																								docs
																									.filter((d) => d.barcode)
																									.map((d) => d.barcode.split("-"))
																									.includes(bc)
																									? "green"
																									: "grey"
																							}
																							key={`bc-${bc}`}
																						>
																							{" "}
																							<Icon name="barcode" />
																							<span style={{ color: "orange" }}>FPA : </span>
																							{bc} <Icon name="delete" onClick={(e) => pullBarcodeFPA(bc, values, setFieldValue)} />
																						</Label>
																					</div>
																				))}
																			{barcodes
																				.filter((bc) => bc.presc === prescription)[0]
																				?.bc.other?.map((bc) => (
																					<div key={`bc-other-${prescription}-${bc.bc}`}>
																						<Label
																							basic={
																								docs &&
																								docs
																									.filter((d) => d.barcode)
																									.map((d) => d.barcode.split("-"))
																									.includes(bc)
																									? false
																									: true
																							}
																							color={
																								docs &&
																								docs
																									.filter((d) => d.barcode)
																									.map((d) => d.barcode.split("-"))
																									.includes(bc)
																									? "green"
																									: "grey"
																							}
																							key={`bc-oth-${bc.bc}`}
																						>
																							{" "}
																							<Icon name="barcode" />
																							<span style={{ color: "teal" }}>{bc.title} : </span>
																							{bc.bc} <Icon name="delete" onClick={(e) => pullBarcodeOther(bc.bc, values, setFieldValue)} />
																						</Label>
																					</div>
																				))}
																		</div>
																		{selectedPresc === prescription && (
																			<div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", minHeight: "150px" }}>
																				<div style={{ display: "flex", justifyContent: "space-evenly" }}>
																					<Field
																						autoFocus
																						component={CustomInputTextComponent}
																						name="scannedBarCode"
																						customlabel="Code-barres de l'ordonnance"
																						onKeyDown={(e) => {
																							handleKeyDown(e, values, setFieldValue);
																						}}
																						onKeyUp={(e) => {
																							handleKeyUp(e, values, setFieldValue);
																						}}
																					/>
																					{deposit && (
																						<Field
																							autoFocus
																							component={CustomInputTextComponent}
																							name="scannedBarCodeFPA"
																							customlabel="Code-barres de la FPA"
																							onKeyDown={(e) => {
																								handleKeyDownFPA(e, values, setFieldValue);
																							}}
																							onKeyUp={(e) => {
																								handleKeyUpFPA(e, values, setFieldValue);
																							}}
																							style={{ marginLeft: "1em" }}
																						/>
																					)}
																				</div>
																				{!otherDocumentType && (
																					<Button icon="plus" onClick={() => setOtherDocumentType(true)} label="Ajouter un autre type de documents" />
																				)}
																				{otherDocumentType && (
																					<Segment>
																						<Label corner="right" onClick={() => setOtherDocumentType(false)} icon="remove" />
																						<Field
																							component={Select}
																							name="documentType"
																							customlabel="Veuillez sélectionner un type de document"
																							placeholder="Sélectionner un type de document"
																							options={
																								documentTypeOptions
																									? documentTypeOptions.map((option) => {
																											return {
																												value: option.id,
																												label: option.title,
																											};
																									  })
																									: []
																							}
																						/>
																						<Field
																							autoFocus
																							component={CustomInputTextComponent}
																							name="scannedBarCodeOther"
																							customlabel="Code-barres"
																							onKeyDown={(e) => {
																								handleKeyDownOther(e, values, setFieldValue);
																							}}
																							onKeyUp={(e) => {
																								handleKeyUpOther(e, values, setFieldValue);
																							}}
																							style={{ marginLeft: "1em" }}
																						/>
																					</Segment>
																				)}
																			</div>
																		)}
																	</Segment>
																))}

																<Segment basic>
																	<Grid>
																		<Grid.Row>
																			<Popup
																				content="Ajouter une prescription"
																				position="bottom center"
																				trigger={
																					<Grid.Column>
																						<>
																							<Header icon>
																								<Icon name="copy" />
																							</Header>
																							<div>
																								<Button icon="plus" onClick={() => addPrescription()} />
																							</div>
																						</>
																					</Grid.Column>
																				}
																			/>
																		</Grid.Row>
																	</Grid>
																</Segment>
															</Segment.Group>
														)}
													</Grid.Column>
												</Grid.Row>
											</Grid>

											<Form>
												<Field
													customlabel="Alerte pour la secrétaire"
													component={Checkbox}
													name="othersComment"
													id="othersComment"
													label="othersComment"
													style={{ marginTop: 0 }}
													readOnly={!firstTvSec}
												/>
												<Field
													component={CustomTextareaComponent}
													name="support_reason"
													customlabel="Saisissez ici plus d'informations."
													required={values.othersComment}
													rows="4"
												/>
												Commentaires rapides :
												<ShortcutComment
													comments={
														firstTvSec
															? [
																	"Ne saisir que les urines",
																	"Ne saisir que les selles",
																	"Ne saisir que le bilan sanguin",
																	"Ordonnance périmée vue",
																	"Copie patient papier",
																	"Saisir Glycémie sur tube Fluoré",
															  ]
															: [
																	"Analyse manquante : ",
																	"Doute analyse : ",
																	"Ne saisir que les urines",
																	"Ne saisir que les selles",
																	"Ne saisir que le bilan sanguin",
																	"Ordonnance périmée vue",
																	"Copie patient papier",
																	"Saisir Glycémie sur tube Fluoré",
															  ]
													}
													fieldName="support_reason"
													fieldValue={values.support_reason}
													setFieldValue={setFieldValue}
												/>
											</Form>
										</Segment>
									</Grid.Column>
								)}
								{deposit && (
									<Grid.Column>
										<Header as="h5" attached="top">
											{" "}
											Informations à remplir lors d'un dépot
										</Header>
										<Segment attached>
											<Grid.Column>
												<Field
													component={Select}
													name="externalSampler"
													customlabel="Préleveur"
													placeholder="Préleveur externe"
													options={
														deposit_samplers && deposit_samplers.length > 0
															? deposit_samplers.map((sampler) => ({
																	value: sampler.code_sil,
																	label: `${sampler.code_sil} - ${sampler.name}`,
															  }))
															: [
																	{ label: "DRE - Docteur externe", value: "DRE" },
																	{ label: "IE - Infirmier externe", value: "IE" },
																	{ label: "BNLACREER - Préleveur Bionext à créer", value: "BNLACREER" },
															  ]
													}
													required
												/>
												<div>
													Date et heure de prélèvement <span style={styles.crossRequired}>*</span>{" "}
													<DatePicker
														selected={prelDate}
														showTimeSelect
														timeFormat={process.env.REACT_APP_TIME_DISPLAY_FORMAT}
														timeIntervals={5}
														timeCaption="time"
														dateFormat={`${process.env.REACT_APP_DATE_DATEPICKER}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`}
														locale="fr"
														className="custom-input"
														calendarClassName="calendar-container"
														required
														onChange={(date) => {
															setPrelDate(date);
														}}
													/>
												</div>

												<Field
													component={Select}
													name="prel_place"
													customlabel="Lieu de prélèvement"
													placeholder="Lieu de prélèvement"
													options={
														deposit_places && deposit_places.length > 0
															? deposit_places.map((deposit_place) => ({
																	value: deposit_place.abbreviation,
																	label: `${deposit_place.abbreviation} - ${deposit_place.name}`,
															  }))
															: [
																	{ label: "En centre", value: "CENTRE" },
																	{ label: "Dr Cabin", value: "CAB" },
																	{ label: "A domicile", value: "DOM" },
															  ]
													}
													required
												/>
												{values.prel_place && deposit_places && deposit_places.filter((p) => p.abbreviation === values.prel_place) && (
													<Field
														component={CustomInputTextComponent}
														autoFocus
														autoComplete="off"
														customlabel="Numéro séquentiel"
														type="text"
														name="numSeq"
														style={{ maxWidth: "200px" }}
														required={
															values.prel_place &&
															deposit_places &&
															deposit_places.filter((p) => p.abbreviation === values.prel_place).length > 0 &&
															deposit_places.filter((p) => p.abbreviation === values.prel_place)[0].numSeqNotRequiredForDeposit
																? false
																: true
														}
													/>
												)}

												{values.prel_place &&
													deposit_places &&
													deposit_places.filter((p) => p.abbreviation === values.prel_place).length > 0 &&
													deposit_places.filter((p) => p.abbreviation === values.prel_place)[0].requireTypeDomicile && (
														<>
															<Field
																component={Select}
																name="domicile"
																customlabel="Domicile"
																placeholder="Domicile"
																options={[
																	{ label: "Prescrit", value: "PRESCR" },
																	{ label: "Demande patient", value: "PATIENT" },
																]}
																required
															/>
															<Field
																component={Select}
																name="rdv"
																customlabel="Rendez-vous"
																placeholder="Type de rendez-vous"
																options={[
																	{ label: "Attribué par le laboratoire au partenaire", value: "LABO" },
																	{ label: "Pris en direct avec le partenaire et dépôt au labo", value: "PARTNER" },
																]}
																required
															/>
														</>
													)}
											</Grid.Column>
										</Segment>
									</Grid.Column>
								)}
							</Grid>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
								Annuler
							</Button>

							<Button
								primary
								disabled={
									(tvsec &&
										(!docs || docs.length === 0) &&
										barcodes.flatMap((bc) => bc.bc.fpa?.length + bc.bc.ordo?.length + bc.bc.other?.length)[0] === 0) ||
									(deposit && !prelDate)
								}
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submitForm();
								}}
							>
								Envoyer ma demande
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default AddNurseHelpModal;
